import { Link, useLocation } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";

export default function NotFound() {
  const location = useLocation();

  return (
    <SiteLayout>
      <div className="mx-auto flex w-full max-w-[1280px] flex-col items-center px-4 py-24 text-center md:px-8 md:py-32">
        <span className="font-heading text-[5rem] font-black leading-none text-primary-100 md:text-[8rem]">
          404
        </span>
        <h1 className="mt-4 font-heading text-2xl font-bold text-foreground-950">
          这个页面可能已经被下架或更换了地址
        </h1>
        <p className="mt-3 max-w-md text-sm leading-relaxed text-foreground-600">
          你访问的地址是 <span className="text-foreground-800">{location.pathname}</span>
          ，目前没有对应内容。可以回到首页，或者到每日合集里找找你想看的话题。
        </p>
        <div className="mt-8 flex flex-col gap-3 sm:flex-row">
          <Link
            to="/"
            className="inline-flex items-center justify-center gap-1.5 whitespace-nowrap rounded-full bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors duration-200 hover:bg-primary-600"
          >
            <span className="flex h-4 w-4 items-center justify-center">
              <i className="ri-home-4-line text-base"></i>
            </span>
            回到首页
          </Link>
          <Link
            to="/daily"
            className="inline-flex items-center justify-center gap-1.5 whitespace-nowrap rounded-full border border-background-300/70 px-6 py-3 text-sm font-medium text-foreground-700 transition-colors duration-200 hover:border-primary-300 hover:text-primary-700"
          >
            <span className="flex h-4 w-4 items-center justify-center">
              <i className="ri-newspaper-line text-base"></i>
            </span>
            浏览每日合集
          </Link>
        </div>
      </div>
    </SiteLayout>
  );
}